import React, { createContext, useContext, useState, useMemo, useEffect } from "react";

const EngineContext = createContext(null);

export function EngineProvider({ children }) {
  // persist config so Optimize/Results survive refresh
  const [config, setConfig] = useState(() => {
    try { return JSON.parse(localStorage.getItem("meten_config") || "{}"); }
    catch { return {}; }
  });
  const [result, setResult] = useState(null);

  useEffect(() => {
    try { localStorage.setItem("meten_config", JSON.stringify(config || {})); } catch {}
  }, [config]);

  const value = useMemo(() => ({ config, setConfig, result, setResult }), [config, result]);
  return <EngineContext.Provider value={value}>{children}</EngineContext.Provider>;
}

export function useEngine() {
  const ctx = useContext(EngineContext);
  if (!ctx) throw new Error("useEngine must be used within <EngineProvider>");
  return ctx;
}
